import { Stack } from "@mui/material";
import { PlaybookTitle } from "./PlaybookTitle";
import { UlList } from "./UlList";
import { useEffect } from "react";

export const CRMNotes = ({
  list,
  setTopic,
}: {
  list: string[];
  setTopic: (topic: string) => void;
}) => {
  const topic = "CRM Notes to Capture";

  useEffect(() => {
    setTopic(topic);
  }, [topic]);

  return (
    <Stack gap={"20px"} id={topic}>
      <PlaybookTitle text={topic} />
      <UlList text={[]} items={list} />
    </Stack>
  );
};
